import { ImageOutlined, InfoOutlined, ThreeSixty } from '@material-ui/icons';
import { DocumentCollectionItemT, ObjectContainerClientDataT, ObjectContainerClientT } from 'bovaljaren-models';
import React, { ReactElement, useContext, useState } from 'react';
import { hasNavigator } from '../../../../../App';
import BrandingService from '../../../../../services/branding.service';
import { AppContext } from '../../../../../state/app.state';
import { isMobile } from '../../../../../utils/app.helper';
import MailToButton from '../../../../interaction/buttons/MailToButton/MailToButton';
import { ToggleValuesT } from '../../Desktop/ObjectView';

type ObjectViewMobileButtonsProps={
    isFavored: boolean;
    toggleFavorite: () => void;
    showIframeOne?: boolean;
    videoButton?: boolean;
    externalUrl?: string;
    showIframeTwo: boolean;
    hasTour?: boolean;
    shareButton?: boolean;
    likeButton?: boolean;
    toggleShow: (value: ToggleValuesT) => void;
    selectedObject?: ObjectContainerClientT;
    imageButton: boolean;
    showImage: boolean;
    documentButton?: boolean;
    setShowDocumentModal?: (value: boolean) => void;
    showVideo: boolean;
};

const ObjectViewMobileButtons: React.FC<ObjectViewMobileButtonsProps> = ({ imageButton, showImage, isFavored, toggleFavorite, showVideo, showIframeOne, hasTour, documentButton, setShowDocumentModal, videoButton, toggleShow, externalUrl, showIframeTwo, shareButton = false, likeButton = false, selectedObject }): ReactElement => {
    const { state, handleSharing, presentationState } = useContext(AppContext);

    return (
        <>
            <div className='bv-object-view-mobile-buttons'>
                {imageButton && <ObjectViewMobileButton
                    label={'Bilder'}
                    inactive={showImage}
                    onClick={(): void => {
                        toggleShow('images');
                    }}/>}
                {likeButton && <ObjectViewMobileButton onClick={toggleFavorite} inactive={isFavored} onClickOverride={true} label={isFavored ? 'Sparad' : 'Spara' }/>}
                {shareButton && <ObjectViewMobileButton
                    label={'Dela'}
                    onClick={(): void => {

                        if (window.navigator || isMobile()) {
                            handleSharing(`Besök ${state?.project?.name}!`, `https://${window.location.hostname}/bv/v3/project/${state?.project?.id || ''}`);
                        }
                        else {
                            state?.setShareLink && state.setShareLink({ value: `https://${window.location.hostname}/bv/v3/project/${state.project?.id || ''}` });
                            presentationState?.setShowShareModal(true);
                        }
                    }}/>}
                {documentButton && <ObjectViewMobileButton
                    label={'Dokument'}
                    onClick={(): void => {
                        setShowDocumentModal && setShowDocumentModal(true);
                    }}/>}
                {selectedObject?.iframeOneId &&
                            <ObjectViewMobileButton inactive={showIframeOne} onClick={():void => toggleShow('iframe1')} label={state?.project?.tours?.find(t => t.id === selectedObject.iframeOneId)?.label || 'IFrame1'}/>}

                {selectedObject?.iframeTwoId &&
                        <ObjectViewMobileButton inactive={showIframeTwo} onClick={():void => toggleShow('iframe2')} label={state?.project?.tours?.find(t => t.id === selectedObject.iframeTwoId)?.label || 'IFrame2'}/>}
                {videoButton && <ObjectViewMobileButton
                    inactive={showVideo}
                    label={'Video'}
                    onClick={(): void => {
                        toggleShow('video');
                    }}>
                </ObjectViewMobileButton>}
                {(state?.project?.interestForm) && selectedObject &&
                            <ObjectViewMobileButton onClick={():void => toggleShow('interestform')} label={'Intresseanmälan'}/>}
            </div>
            {(BrandingService.check(['obos']) || selectedObject?.externalUrl) && selectedObject &&
                <div className='bv-objectview-button bv-objectview-button--fullwidth'
                    onClick={(): void => {
                        if (selectedObject?.externalUrl) {
                            const link = document.createElement('a');
                            link.target = '_blank';
                            link.href = selectedObject.externalUrl || '';
                            link.addEventListener('click', (event) => {

                                return false;
                            });
                            link.click();
                            link.remove();
                        }
                        else if (state?.pymContextFrame?.active && state?.pymContextFrame.sendMessage) {
                            state?.pymContextFrame.sendMessage('navigate',
                                JSON.stringify({
                                    propertyID: selectedObject?.externalSyncId,
                                    url: '#property-details'
                                }));
                        }
                    }}>
                    <div className='bv-objectview-button--external-link'>
                        <div className='bv-objectview-button-content'>
                            {BrandingService.check(['obos']) ? 'Läs mer och anmäl intresse' : 'Läs mer'}
                        </div>
                    </div>
                </div>}
        </>

    );
};


export default ObjectViewMobileButtons;



const ObjectViewMobileButton: React.FC<{onClick?: () => void; label: string, inactive?: boolean, onClickOverride?: boolean }> = ({ label, onClick, inactive = false, onClickOverride = false }) => <div onClick={(inactive && !onClickOverride) ? undefined : onClick} className={`bv-object-view-mobile-button ${inactive ? 'bv-object-view-mobile-button-inactive' : ''}`}><ObjectViewMobileButtonContent>{label}</ObjectViewMobileButtonContent></div>;
const ObjectViewMobileButtonContent: React.FC = ({ children }) => <div className='bv-objectview-button-content'>{children}</div>;
